import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
// import { SELECTED_ITEM_COLOR } from '@CSSVars/colors'
export const _TermsUseText = styled.div`
  width: fit-content;
  margin: 0 auto;
  > div { color: white; line-height: 22px;}
`
